
import { 
  FeatureSource 
} from "@models/FeatureSource";
import { 
  IStringNumHash, 
  FeatureBase 
} from "@models";
import { 
  Creature,
  IStringUpgradableNumberHash,
  CharacterLimitation,
  UpgradableNumber,
  Item,
  MagicItemKeyword,
  AttachedTable,
} from "@dndModels";
import { FEATURE_SOURCE_TYPE_TO_NAME_MAP } from "@dndModels/Constants";
import { ColorsType } from "../../../../DandDPalette";
import DandDAPI from "@dndUtilities/system_api";

const api = DandDAPI.getInstance();

export class DandDFeatureSource extends FeatureSource {
  // game_system: string = "D&D";
  formulae: IStringUpgradableNumberHash = {};
  limitations: CharacterLimitation[] = [];
  table: AttachedTable = new AttachedTable();

  colors: ColorsType = {
    backgroundColor: "",
    color: "Default"
  }

  constructor(obj?: any, fs_type?: string) {
    super(obj);
    if (obj) {
      this.limitations = [];
      if (obj.limitations) {
        obj.limitations.forEach((l: any) => {
          this.limitations.push(new CharacterLimitation(l));
        });
      } else if (obj.race_ids && obj.race_ids.length > 0) {
        const limitation = new CharacterLimitation();
        limitation.type = "race";
        limitation.ids = obj.race_ids;
        this.limitations.push(limitation);
      } else {
        if (obj.data_type === "eldritch_invocation") {
          if (obj.level && obj.level > 0) {
            const limitation = new CharacterLimitation();
            limitation.type = "game_class";
            limitation.ids = ["5fefa7477494ba20cca8aa19"];
            limitation.values = [obj.level];
            this.limitations.push(limitation);
          }
          const pact_boon_id = obj.pact_boon_id ? obj.pact_boon_id : (obj.pact ? obj.pact : "None");
          if (!["None","undefined",""].includes(pact_boon_id)) {
            const limitation = new CharacterLimitation();
            limitation.type = "pact_boon";
            limitation.ids = [pact_boon_id];
            this.limitations.push(limitation);
          }
        } else if (obj.data_type === "gift") {
          if (obj.race_id) {
            const limitation = new CharacterLimitation();
            limitation.type = "race";
            limitation.ids = [obj.race_id];
            this.limitations.push(limitation);
          }
        }
      }
      this.table = obj.table ? new AttachedTable(obj.table) : new AttachedTable();
      this.formulae = {};
      if (obj.formulae && obj.formulae.length > 0) {
        obj.formulae.forEach((form: any) => {
          const key = form.key;
          const formula = form.formula;
          this.formulae[key] = new UpgradableNumber(formula);
        });
      }
      if (this.source_book_ids.length === 0) {
        this.source_books_old.push({ type: "Source Book", id: "63cd69a14d337b1738dab548", third_party: false });
      }
      
      this.colors = obj.colors ? obj.colors : {
        backgroundColor: "",
        color: "Default"
      };
      if (!["Default","Black","White",undefined].includes(this.colors.color)) {
        this.colors.color = "Default";
      }
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.limitations = [];
  //     if (obj.limitations) {
  //       for (const l of obj.limitations) {
  //         this.limitations.push(new CharacterLimitation(l));
  //       }
  //     } else if (obj.race_ids && obj.race_ids.length > 0) {
  //       const limitation = new CharacterLimitation();
  //       limitation.type = "race";
  //       limitation.ids = obj.race_ids;
  //       this.limitations.push(limitation);
  //     } else {
  //       if (obj.data_type === "eldritch_invocation") {
  //         if (obj.level && obj.level > 0) {
  //           const limitation = new CharacterLimitation();
  //           limitation.type = "game_class";
  //           limitation.ids = ["5fefa7477494ba20cca8aa19"];
  //           limitation.values = [obj.level];
  //           this.limitations.push(limitation);
  //         }
  //         const pact_boon_id = obj.pact_boon_id ? obj.pact_boon_id : (obj.pact ? obj.pact : "None");
  //         if (!["None","undefined",""].includes(pact_boon_id)) {
  //           const limitation = new CharacterLimitation();
  //           limitation.type = "pact_boon";
  //           limitation.ids = [pact_boon_id];
  //           this.limitations.push(limitation);
  //         }
  //       } else if (obj.data_type === "gift") {
  //         if (obj.race_id) {
  //           const limitation = new CharacterLimitation();
  //           limitation.type = "race";
  //           limitation.ids = [obj.race_id];
  //           this.limitations.push(limitation);
  //         }
  //       }
  //     }
  //     this.table = obj.table ? new AttachedTable(obj.table) : new AttachedTable();
  //     this.formulae = {};
  //     // if (this.name.includes("Monk")) {
  //     //   debugger;
  //     // }
  //     if (obj.formulae) {
  //       if (obj.formulae.length) {
  //         for (const form of obj.formulae) {
  //           const key = form.key;
  //           const formula = form.formula;
  //           this.formulae[key] = new UpgradableNumber(formula);
  //         }
  //       } else {
  //         const keys = Object.keys(obj.formulae);
  //         if (keys.length > 0) {
  //           keys.forEach(key => {
  //             this.formulae[key] = obj.formulae[key].clone();
  //           });
  //         }
  //       }
  //     }
  //     if (this.source_book_ids.length === 0) {
  //       this.source_books_old.push({ type: "Source Book", id: "63cd69a14d337b1738dab548", third_party: false });
  //     }
      
  //     this.colors = obj.colors ? obj.colors : {
  //       backgroundColor: "",
  //       color: "Default"
  //     };
  //     if (!["Default","Black","White",undefined].includes(this.colors.color)) {
  //       this.colors.color = "Default";
  //     }
  //   }
  // }

  get_detail_format() {
    let str = super.get_detail_format();
    // if (this.name.includes("Astral")) {
    //   debugger;
    // }
    if (this.limitations.length > 0) {
      str += "; Prerequisites : ("; 
      str += this.limitations.map(o => o.toDetailString()).join(", ")
      str += ")";
    }
    return str.trim();
  }

  get ability_scores() {
    return this.feature_bases.flatMap(o => o.ability_scores);
  }

  get asi_min() {
    const amounts = this.feature_bases.flatMap(o => o.asi_min);
    return amounts.length > 0 ? Math.max(...amounts) : 0;
  }

  get the_utility_details() {
    return this.feature_bases.flatMap(o => o.the_utility_details);
  }

  get_homebrewery_string(): string {
    let str = `# ${this.true_name}\n\r`;
    str += `${this.description}\n\r`;
    str += this.get_homebrewery_fbs_string();
    return str;
  }

  get_homebrewery_fbs_string(): string {
    let str = "";
    const fbs = this.feature_bases.sort((a, b) => {
      if (a.level === b.level) {
        return a.name.localeCompare(b.name);
      } else {
        return +a.level < +b.level ? -1 : 1;
      }
    });
    let level = 0;
    for (const fb of fbs) {
      if (level !== fb.level) {
        level = fb.level;
        str += `## Level ${level}\n\r`;
      }
      switch (fb.multiclassing) {
        case 0: str += `### ${fb.name}\n\r`; break;
        case 1: str += `### ${fb.name} (First Class Only)\n\r`; break;
        default: str += `### ${fb.name} (Multiclassed)\n\r`; break;
      }
      str += `${fb.description}\n\r`;
    }
    // const ofbs = api.get_optional_features([this]).sort((a, b) => {
    //   if (a.level === b.level) {
    //     return a.name.localeCompare(b.name);
    //   } else {
    //     return +a.level < +b.level ? -1 : 1;
    //   }
    // });
    // if (ofbs.length > 0) {
    //   level = 0;
    //   str += `# Optional Features\n\r`;
    //   for (const fb of ofbs) {
    //     if (level !== fb.level) {
    //       level = fb.level;
    //       str += `## Level ${level}\n\r`;
    //     }
    //     str += `### ${fb.name}\n\r`;
    //     str += `${fb.description}\n\r`;
    //   }
    // }
    return str;
  }

  toDBObj(): any {
    const super_obj = super.toDBObj();
    const formulae: any[] = [];
    Object.keys(this.formulae).forEach(key => {
      const form: any = {};
      form.key = key;
      form.formula = this.formulae[key].toDBObj();
      formulae.push(form);
    });
    return {
      ...super_obj,
      limitations: this.limitations.map(o => o.toDBObj()),
      formulae,
      table: this.table.toDBObj(),
      colors: this.colors
    };
  }

  toLight(): any {
    const super_obj = super.toLight();
    return {
      ...super_obj,
      limitations: this.limitations.map(o => o.toDBObj()),
      colors: this.colors
    };
  }

  get total_feature_points(): number {
    return this.feature_bases.reduce((accumulator: number, fp: FeatureBase) => {
      return accumulator + fp.total_feature_points;
    }, 0);
  }

  get total_avg_feature_points(): number {
    return this.feature_bases.reduce((accumulator: number, fp: FeatureBase) => {
      return accumulator + fp.total_avg_feature_points;
    }, 0);
  }

  get total_feature_points_by_level(): IStringNumHash {
    const return_me: IStringNumHash = {};
    this.feature_bases.forEach(fb => {
      if (return_me[fb.level]) {
        return_me[fb.level] += fb.total_feature_points;
      } else {
        return_me[fb.level] = fb.total_feature_points;
      }
    });
    return return_me;
  }

  get total_avg_feature_points_by_level(): IStringNumHash {
    const return_me: IStringNumHash = {};
    this.feature_bases.forEach(fb => {
      if (return_me[fb.level]) {
        return_me[fb.level] += fb.total_avg_feature_points;
      } else {
        return_me[fb.level] = fb.total_avg_feature_points;
      }
    });
    return return_me;
  }

  get feature_source_type_name() {
    const name = FEATURE_SOURCE_TYPE_TO_NAME_MAP[this.data_type];
    if (name) {
      return name;
    }

    return this.feature_source_type;
  }

  copy(copyMe: FeatureSource, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof DandDFeatureSource) {
      this.limitations = copyMe.limitations.map(o => o.clone());
      this.formulae = {};
      Object.keys(copyMe.formulae).forEach(key => {
        this.formulae[key] = copyMe.formulae[key].clone();
      });
      this.table = copyMe.table.clone();
      this.colors = {...copyMe.colors};
    }
  }

  specialCopy(copyMe: FeatureSource | Creature): void {
    this.name = copyMe.name + " (Special Copy)";
    this.description = copyMe.description;
    this.source_books_old = [];
    copyMe.source_books_old.forEach(sb => {
      this.source_books_old.push({...sb});
    });
    if (copyMe instanceof Creature) {
      this.limitations = [];
      this.feature_bases = [];
      // A lot of the things about Creatures aren't part of a feature,
      // but these things are, so we can copy them.  
      // Other things would have to be done manually.
      for (const fb of copyMe.action_fbs) {
        const newFB = fb.clone(true);
        newFB.name = `Action: ${fb.name}`;
        this.feature_bases.push(newFB);
      }
      for (const fb of copyMe.lair_action_fbs) {
        const newFB = fb.clone(true);
        newFB.name = `Lair Action: ${fb.name}`;
        this.feature_bases.push(newFB);
      }
      for (const fb of copyMe.traits) {
        const newFB = fb.clone(true);
        newFB.name = `Trait: ${fb.name}`;
        this.feature_bases.push(newFB);
      }
      for (const fb of copyMe.legendary_action_fbs) {
        const newFB = fb.clone(true);
        newFB.name = `Legendary Action: ${fb.name}`;
        this.feature_bases.push(newFB);
      }
      this.table = copyMe.table.clone();
    } else if (copyMe instanceof DandDFeatureSource) {
      this.limitations = copyMe.limitations.map(o => o.clone());
      this.feature_bases = copyMe.feature_bases.map(o => { return o.clone(true); });
      if (copyMe instanceof Item && this instanceof MagicItemKeyword) {
        this.base_item_types = [copyMe.item_type];
        this.min_rarity = copyMe.min_rarity;
        this.max_rarity = copyMe.max_rarity;
        this.name_formula = copyMe.name_formula;
        this.rarity_names = {...copyMe.rarity_names};
        this.recipes = copyMe.recipes.map(o => o.clone());
        this.charges = copyMe.charges;
        this.charge_refresh_rule = copyMe.charge_refresh_rule;
        this.attunement = copyMe.attunement;
      } else if (copyMe instanceof MagicItemKeyword && this instanceof Item) {
        this.item_type = copyMe.base_item_types.length > 0 ? copyMe.base_item_types[0] : "Other";
        this.min_rarity = copyMe.min_rarity;
        this.max_rarity = copyMe.max_rarity;
        this.name_formula = copyMe.name_formula;
        this.rarity_names = {...copyMe.rarity_names};
        this.charges = copyMe.charges;
        this.charge_refresh_rule = copyMe.charge_refresh_rule;
        this.attunement = copyMe.attunement;
      }
      this.table = copyMe.table.clone();
    }
  }

  clone(drop_ids = false): DandDFeatureSource {
    const new_obj = new DandDFeatureSource();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}